<li #drop ngbDropdown class="nav-item dropdown-notification ">
  <a placement="bottom" ngbTooltip="{{ 'Global.lcom' | translate}}" class="nav-link" ngbDropdownToggle id="navbarCommDropdown"
    ><i class=" fa fa-quote-left"></i
    ></a
  >
  <ul
    ngbDropdownMenu
    aria-labelledby="navbarCommDropdown"
    class="dropdown-menu dropdown-menu-media customrtl"
  >
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0">{{ 'Global.avis' | translate}}</h4>
      </div>
    </li>
    <!--/ Notifications header -->

    <!-- Notifications content -->
    <li class="scrollable-container media-list" [perfectScrollbar]>
      
      <div class="form-group ml-1 mt-2 mr-1">
        <fieldset class="form-label-group">
          <textarea maxlength="300" [(ngModel)]="msg" class="form-control" id="label-textarea" rows="3" placeholder="{{ 'placeholder.davis' | translate}}"></textarea>
          <label for="label-textarea">{{ 'Global.com' | translate}}</label>
        </fieldset>
      </div>
      <div class="d-flex align-items-center ml-2">
        <small class="text-muted mr-75">{{ 'Global.noter' | translate}}</small>
        <div class="employee-task-chart-primary-1">
          <div class="form-group">
            <div class="rating">
              <ngb-rating max="5" [formControl]="ctrl" class="outline-none"></ngb-rating>
            </div>
          </div>
        </div>
      </div>
      
    <!--/ Notifications content -->

    <!-- Notifications footer -->
    <li class="dropdown-menu-footer">
      <a (click)="com()" class="btn btn-primary btn-block" href="javascript:void(0)">{{ 'Global.env' | translate}} </a>
    </li>
    <!--/ Notifications footer -->
  </ul>
</li>
